import api from './api';
import type { AttributionReport, ClientItem } from '../models/attribution';

export interface ClientListResponse {
  count?: number;
  results?: ClientItem[];
}

export const attributionApi = {
  getStats: async (params?: {
    days?: number;
    platform?: string;
    app?: string;
  }): Promise<AttributionReport> => {
    const response = await api.get('/app/clients/attribution/', { params });
    return response.data;
  },

  getClients: async (params?: {
    page?: number;
    page_size?: number;
    search?: string;
    has_referrer?: boolean;
    platform?: string;
  }): Promise<ClientItem[]> => {
    const response = await api.get('/app/clients/', { params });
    if (Array.isArray(response.data)) {
      return response.data;
    }
    if (response.data && Array.isArray(response.data.results)) {
      return response.data.results;
    }
    return [];
  },
};

export default attributionApi;
